import About from "../components/About";
import InHouseFacilities from "../components/InHouseFacilities";
import Manufacturing from "../components/Manifacturing";
import NewPlant from "../components/NewPlant";
import OduChassis from "../components/OduChassis";
import SectionSeparator from "../components/Seperator";

export default function Infrastructure() {
    return (
        <>
            <About />
            {/* <InHouseFacilities/> */}
            <OduChassis/>
            <Manufacturing/>
            <SectionSeparator />
        </>
    );
}